import React from 'react';

import { Grid } from '@mui/material';

import ParentRule from '../ParentRule';
import Process from '../Process';
import EntitiesToCheck from '../EntitiesToCheck';
import TransactionTypesAssignment from '../TransactionTypesAssignment';

const RuleTriggers = () => (
  <Grid container spacing={6}>
    <Grid size={12}>
      <ParentRule />
    </Grid>
    <Process />
    <EntitiesToCheck />
    <TransactionTypesAssignment />
  </Grid>
);
export default RuleTriggers;
